import {
  Card,
  Spin,
  Typography,
  Row,
  Icon,
  Col,
  Empty,
  DatePicker,
} from "antd";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  XAxis,
  YAxis,
  Line,
  LineChart,
  Tooltip,
} from "recharts";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { AccountService } from "../../services/account/AccountService";
import { handleError } from "../../utils/ErrorHandlers";
import Page from "../general/Page";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import ResponsiveContainer from "recharts/lib/component/ResponsiveContainer";
import moment from "moment";
import { Translation, withTranslation } from "react-i18next";
import i18next from "i18next";
import "moment/locale/ar";
const { RangePicker } = DatePicker;

class AgentDashboard extends Component {
  constructor(props) {
    super(props);
    this.props.context.setCurrentComponent("agentDashboard");
    this.acc = new AccountService();
    this.state = {
      isFetching: false,
      data: {},
      averageHandlingTime: [],
      agentStates: [],
      lang:
        this.props.context.curr_lang === "ar" &&
        this.props.context.curr_dir === "rtl"
          ? "ar"
          : "en",
    };
  }

  async componentDidMount() {
    try {
      this.setState({ isFetching: true });
      let from = moment()
        .locale(this.state.lang)
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss")
        .toString();
      let to = moment()
        .locale(this.state.lang)
        .format("YYYY-MM-DD HH:mm:ss")
        .toString();

      let data = await this.getAgentData(from, to);
      let agentGraphsData = await this.getAgentGraphsData(from, to);
      this.setState({
        isFetching: false,
        data: data,
        averageHandlingTime: this.generateDataDuring24hr(
          agentGraphsData.averageHandlingTime
        ),
        agentStates: this.generateStates(agentGraphsData.agentStates),
      });
    } catch (e) {
      this.setState({ isFetching: false });
      handleError(e);
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.location.key !== this.props.location.key) {
      this.componentDidMount();
    }
  }
  generateDataDuring24hr(data) {
    let result = [];
    for (let i = 0; i <= 24; i++) {
      const found = data.some((el) => el.hour == i);
      if (!found) {
        result.push({ hour: i + "", Duration: 0 });
      } else {
        let obj = data.find((o) => o.hour == i);
        result.push(obj);
      }
    }
    return result;
  }
  generateStates(data) {
    let found = data.some((el) => el.state == "AUX");
    if (!data.some((el) => el.state == "AUX")) {
      data.push({ state: "AUX" + "", Duration: 0 });
    }
    if (!data.some((el) => el.state == "BREAK")) {
      data.push({ state: "BREAK" + "", Duration: 0 });
    }
    if (!data.some((el) => el.state == "ONLINE")) {
      data.push({ state: "ONLINE" + "", Duration: 0 });
    }

    return data;
  }
  async getAgentData(from, to) {
    try {
      let response = await this.acc.getAgentData(
        this.props.context.session_id,
        from,
        to
      );
      return response.ivrCustomEntityObject;
    } catch (e) {
      this.setState({ isFetching: false });
      handleError(e);
    }
  }

  customTooltipForLine(e) {
    if (e.active && e.payload != null && e.payload[0] != null) {
      let payload = e.payload[0].payload;
      let val = this.extractHrs(payload["hour"]);
      let duration = this.secondsToHms(payload["Duration"]);
      return (
        <Card>
          <div
            style={{
              margin: "10px",
              alignItems: "center",
            }}
          >
            <p>{val}</p>
            <p style={{ color: "#d83a31" }}>Duration: {duration}</p>
          </div>
        </Card>
      );
    } else {
      return "";
    }
  }

  customTooltipForBar(e) {
    if (e.active && e.payload != null && e.payload[0] != null) {
      let payload = e.payload[0].payload;
      let val = payload["state"];

      let duration = this.hrsToHms(payload["Duration"]);
      return (
        <Card>
          <div
            style={{
              margin: "10px",
              alignItems: "center",
            }}
          >
            <p>{i18next.t(val)}</p>
            <p style={{ color: "#d83a31" }}>Duration: {duration}</p>
          </div>
        </Card>
      );
    } else {
      return "";
    }
  }

  extractHrs(hr) {
    let val = 0;
    if (hr == 12) {
      val = hr + " pm";
    } else if (hr == 24) {
      val = hr - 12 + " am";
    } else if (hr < 12) {
      val = hr + " am";
    } else if (hr > 12) {
      val = hr - 12 + " pm";
    }
    return val;
  }

  secondsToHms(num) {
    let d = Number(num);
    var h = Math.floor(d / 3600);
    var m = Math.floor((d % 3600) / 60);
    var s = Math.floor((d % 3600) % 60);

    var hDisplay = h > 0 ? h + (h == 1 ? " hr, " : " hrs, ") : "";
    var mDisplay = m > 0 ? m + (m == 1 ? " min, " : " mins, ") : "";
    var sDisplay = s > 0 ? s + (s == 1 ? " sec" : " secs") : "";
    let duration = hDisplay + mDisplay + sDisplay;

    return duration ? duration : "0 sec";
  }
  hrsToHms(num) {
    let d = Number(num) * 60*60;
    var h = Math.floor(d / 3600);
    var m = Math.floor((d % 3600) / 60);
    var s = Math.floor((d % 3600) % 60);

    var hDisplay = h > 0 ? h + (h == 1 ? " hr, " : " hrs, ") : "";
    var mDisplay = m > 0 ? m + (m == 1 ? " min, " : " mins, ") : "";
    var sDisplay = s > 0 ? s + (s == 1 ? " sec" : " secs") : "";
    let duration = hDisplay + mDisplay + sDisplay;

    return duration ? duration : "0 sec";
  }

  async getAgentGraphsData(from, to) {
    try {
      let response = await this.acc.getAgentGraphsData(
        this.props.context.session_id,
        from,
        to
      );
      return response.ivrCustomEntityObject;
    } catch (e) {
      this.setState({ isFetching: false });
      handleError(e);
    }
  }

  // async onOk(dates) {
  //   let from = dates[0].format("YYYY-MM-DD HH:mm:ss").toString();
  //   let to = dates[1].format("YYYY-MM-DD HH:mm:ss").toString();

  //   try {
  //     this.setState({ isFetching: true });
  //     let data = await this.getAgentData(from, to);
  //     let agentGraphsData = await this.getAgentGraphsData(from, to);

  //     this.setState({
  //       isFetching: false,
  //       data: data,
  //       averageHandlingTime: this.generateDataDuring24hr(
  //         agentGraphsData.averageHandlingTime
  //       ),
  //       agentStates: agentGraphsData.agentStates,
  //     });
  //   } catch (e) {
  //     this.setState({ isFetching: false });
  //     handleError(e);
  //   }
  // }
  render() {
    let { isFetching, data, averageHandlingTime, agentStates } = this.state;
    const { Title } = Typography;
    const { Text } = Typography;

    const translatedAgentStates = agentStates.map((item) => {
      const ret = {
        Duration: Number(item.Duration)/3600,
        // ...item,
        state: i18next.t(item.state),
      };
      return ret;
    });
    return (
      <Translation>
        {(t) => (
          <Page title={t("Dashboard")}>
            <div>
              <Col xs={{ span: 23 }} lg={{ span: 23 }}>
                {/* <Row
                style={{
                  marginTop: "5px",
                  marginBottom: "10px",
                  alignItems: "center",
                  fontSize: "18px",
                }}
              >
                <Col xs={{ span: 24 }} lg={{ span: 12 }}>
                  <RangePicker
                    showTime={true}
                    format={"YYYY-MM-DD HH:mm:ss"}
                    onOk={(e) => this.onOk(e)}
                    placeholder={["from", "to"]}
                    defaultValue={[
                      moment().startOf("day"),
                      moment().endOf("day"),
                    ]}
                  />
                </Col>
              </Row> */}
                {isFetching ? (
                  <Spin></Spin>
                ) : (
                  <div>
                    <Row gutter={24}>
                      <Col xs={{ span: 24 }} lg={{ span: 6 }}>
                        <Row>
                          <Card
                            style={{
                              marginTop: "10px",
                              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                              marginBottom: "10px",
                            }}
                            title={
                              <span>
                                <Icon
                                  className="mirror-icon"
                                  style={
                                    this.props.context.curr_dir === "ltr" &&
                                    this.props.context.curr_lang === "en"
                                      ? { marginRight: 10, color: "#d73a31" }
                                      : { marginLeft: 10, color: "#d73a31" }
                                  }
                                  type="phone"
                                />
                                <Text
                                  style={{
                                    color: "#000000",
                                    fontSize: 20,
                                    textWrap: "wrap",
                                  }}
                                >
                                  {t("Total Answered calls")}
                                </Text>
                              </span>
                            }
                            bordered={true}
                            headStyle={{ height: 60 }}
                          >
                            <p style={{ marginLeft: 25, marginTop: 25 }}>
                              <p>
                                <Title
                                  style={{ fontSize: 25, textAlign: "center" }}
                                >
                                  {data ? data.totalAnsweredCalls : ""}
                                </Title>
                              </p>
                            </p>
                          </Card>
                        </Row>
                        <Row>
                          <Card
                            style={{
                              marginTop: "10px",
                              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                              marginBottom: "10px",
                            }}
                            title={
                              <span>
                                <Icon
                                  className="mirror-icon"
                                  style={
                                    this.props.context.curr_dir === "ltr" &&
                                    this.props.context.curr_lang === "en"
                                      ? { marginRight: 10, color: "#d73a31" }
                                      : { marginLeft: 10, color: "#d73a31" }
                                  }
                                  type="phone"
                                />
                                <Text
                                  style={{
                                    color: "#000000",
                                    fontSize: 20,
                                  }}
                                >
                                  {t("Total Missed calls")}
                                </Text>
                              </span>
                            }
                            bordered={true}
                            headStyle={{ height: 60 }}
                          >
                            <p style={{ marginLeft: 25, marginTop: 25 }}>
                              <p>
                                <Title
                                  style={{ fontSize: 25, textAlign: "center" }}
                                >
                                  {data ? data.totalMissedCalls : ""}
                                </Title>
                              </p>
                            </p>
                          </Card>
                        </Row>
                      </Col>
                      <Col xs={{ span: 24 }} lg={{ span: 18 }}>
                        <Card
                          style={
                            this.props.context.curr_dir === "ltr" &&
                            this.props.context.curr_lang === "en"
                              ? {
                                  marginTop: "10px",
                                  padding: "0px 30px 10px 10px",
                                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                                  marginBottom: "10px",
                                }
                              : {
                                  marginTop: "10px",
                                  padding: "0px 10px 10px 30px",
                                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                                  marginBottom: "10px",
                                }
                          }
                          bordered={false}
                          title={
                            <span style={{ color: "rgba(0, 0, 0, 0.65)" }}>
                              <Icon
                                type="bar-chart"
                                style={{ margin: "10px", color: "#d73a31" }}
                              />
                              <Text style={{ color: "#000000", fontSize: 20 }}>
                                {t("States")}
                              </Text>
                            </span>
                          }
                          headStyle={{
                            backgroundColor: "rgba(255, 255, 255, 0.4)",
                            border: 0,
                            height: 10,
                          }}
                        >
                          <ResponsiveContainer width="100%" height={225}>
                            {agentStates.length !== 0 ? (
                              <BarChart
                                style={
                                  this.props.context.curr_dir === "rtl"
                                    ? { direction: "ltr" }
                                    : { direction: "ltr" }
                                }
                                data={translatedAgentStates}
                                margin={
                                  this.props.context.curr_dir === "ltr" &&
                                  this.props.context.curr_lang === "en"
                                    ? {
                                        top: 20,
                                        right: 30,
                                        left: 20,
                                        bottom: 5,
                                      }
                                    : { top: 20, right: 5, left: 30, bottom: 5 }
                                }
                              >
                                <XAxis
                                  dataKey="state"
                                  strokeWidth={0}
                                  reversed={
                                    this.props.context.curr_dir === "rtl"
                                      ? true
                                      : false
                                  }
                                />
                                <YAxis
                                  unit=" hrs"
                                  orientation={
                                    this.props.context.curr_dir === "rtl"
                                      ? "right"
                                      : "left"
                                  }
                                />
                                <CartesianGrid strokeDasharray="3 3" />
                                <Tooltip
                                  content={(e) => this.customTooltipForBar(e)}
                                />
                                <Legend style={{ float: "left" }} />
                                <Bar
                                  dataKey="Duration"
                                  fill="#d73a31"
                                  radius={3}
                                  barSize={35}
                                  name={t("Duration")}
                                />
                              </BarChart>
                            ) : (
                              <Empty
                                description={i18next.t("Empty")}
                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                              />
                            )}
                          </ResponsiveContainer>
                        </Card>
                      </Col>
                    </Row>

                    <Row gutter={24}>
                      <Col xs={{ span: 24 }} lg={{ span: 24 }}>
                        <Card
                          style={
                            this.props.context.curr_dir === "ltr" &&
                            this.props.context.curr_lang === "en"
                              ? {
                                  padding: "0px 30px 10px 10px",
                                  marginTop: "10px",
                                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                                  marginBottom: "10px",
                                }
                              : {
                                  padding: "0px 10px 10px 30px",
                                  marginTop: "10px",
                                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                                  marginBottom: "10px",
                                }
                          }
                          bordered={false}
                          title={
                            <span style={{ color: "rgba(0, 0, 0, 0.65)" }}>
                              <Icon
                                type="line-chart"
                                style={{ margin: "10px", color: "#d73a31" }}
                              />
                              <Text style={{ color: "#000000", fontSize: 20 }}>
                                {t("Average Handling Time")}
                              </Text>
                            </span>
                          }
                          headStyle={{
                            backgroundColor: "rgba(255, 255, 255, 0.4)",
                            border: 0,
                            height: 10,
                            marginBottom: 10,
                          }}
                        >
                          <ResponsiveContainer width="100%" height={250}>
                            {averageHandlingTime.length !== 0 ? (
                              <LineChart
                                data={averageHandlingTime}
                                style={
                                  this.props.context.curr_dir === "rtl"
                                    ? { direction: "ltr" }
                                    : { direction: "ltr" }
                                }
                              >
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis
                                  dataKey="hour"
                                  strokeWidth={0}
                                  reversed={
                                    this.props.context.curr_dir === "rtl"
                                      ? true
                                      : false
                                  }
                                />
                                <YAxis
                                  strokeWidth={0}
                                  unit="sec"
                                  orientation={
                                    this.props.context.curr_dir === "rtl"
                                      ? "right"
                                      : "left"
                                  }
                                />
                                <Tooltip
                                  content={(e) => this.customTooltipForLine(e)}
                                />
                                <Line
                                  strokeWidth={2}
                                  dataKey="Duration"
                                  stroke="#d73a31"
                                  activeDot={{ r: 8 }}
                                />
                              </LineChart>
                            ) : (
                              <Empty
                                description={i18next.t("Empty")}
                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                              />
                            )}
                          </ResponsiveContainer>
                        </Card>
                      </Col>
                    </Row>
                  </div>
                )}
              </Col>
            </div>
          </Page>
        )}
      </Translation>
    );
  }
}

export default withSharedStateConsumer(withRouter(AgentDashboard));
